import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { ILineResource } from '../../entities/farms.entities';
import { selectFarmsData } from '../../store/farms/farms.selector';
import { selectLang } from '../../store/ui/ui.selector';
import { translate } from '../../lib/lang.helper';
import { displayValueUnit } from '../../lib/common.helpers';
import { selectAccount } from '../../store/auth/auth.selector';
import { FarmDiv, LineDiv } from './CalendarCell';

const unitLabel = (d: any, ut: any) => {
  if (d.current_line_length !== undefined) {
    return displayValueUnit(d.current_line_length, ut, 'distance_m');
  } else if (d.current_basket_count !== undefined) {
    return `${d.current_basket_count} baskets`;
  } else if (d.total_seeded_tank_area !== undefined) {
    return displayValueUnit(d.total_seeded_tank_area, ut, 'area_sqm');
  } else {
    return '';
  }
};

interface Props {
  reqLine: ILineResource;
  onClickAssessment: (d: any) => void;
}

const RequireAssessmentCell = ({ reqLine, onClickAssessment }: Props) => {
  const lang = useSelector(selectLang);
  const unitType = useSelector(selectAccount)?.display_unit;
  const farm = useSelector(selectFarmsData).find(x => x.id === reqLine.farm_id);
  const line = farm?.lines.find(x => x.id === reqLine.id);

  const handleShowClick = (event: any) => {
    event.preventDefault();
    onClickAssessment(line);
  };

  return (
    <div
      className='--entity --require-assessment'
      onClick={handleShowClick.bind(this)}
    >
      <div className='--header'>
        <span>{translate(lang, 'req. assessment')}</span>
      </div>
      <div className='--title'>
        <div className='mt-7'>
          {`${line?.growing_cycle?.main_seed.season_name} - ${unitLabel(
            line?.growing_cycle,
            unitType,
          )}`}
        </div>
        <div className='d-flex flex-wrap gap-7'>
          {farm && <FarmDiv farm={farm} />}
          {line && <LineDiv line={line} />}
        </div>
      </div>
      <div className='--btn-bar'>
        <Link to={`/farms/${farm?.id}/${line?.id}`} className='--view'>
          {translate(lang, 'View')}
        </Link>
      </div>
    </div>
  );
};

export default RequireAssessmentCell;
